import { EditPersonRequest } from "@shared/dtos/requests/personRequests.dto"
import {
  AttestBsnCheckRequest,
  AttestIdentificationVerificationRequest,
} from "@shared/zod/schemas/requests/personRequests"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const edit = (id: string, data: EditPersonRequest): Promise<void> => {
  return axiosAuth({
    url: `/persons/${id}`,
    method: "patch",
    data: data,
  }).then(() => undefined)
}

export const attestIdentificationVerification = (
  id: string,
  data: AttestIdentificationVerificationRequest
): Promise<void> => {
  return axiosAuth({
    url: `/persons/${id}/identificationVerification`,
    method: "post",
    data: data,
  }).then(() => undefined)
}

export const attestBsnCheck = (id: string, data: AttestBsnCheckRequest): Promise<void> => {
  return axiosAuth({
    url: `/persons/${id}/bsnCheck`,
    method: "post",
    data: data,
  }).then(() => undefined)
}
